export default __webpack_public_path__ + "static/canada-e8f7702ef87988c91e2ef121f72f8b52.svg";